import script from "./DashStatsQuery.vue?vue&type=script&lang=js"
export * from "./DashStatsQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__